module.exports = __webpack_public_path__ + "media/images/default-banner-160b762b8b43a9eb020e700290cbae62.png";